/**
 * @desc: - 投注选号 - 全/大/小/奇/偶/清操作
 * @param  {[STRING]} className：   [顶层 class]
 * @param  {[STRING]} title:        [标题]
 * @param  {[STRING]} items:        [选项: 多个选项由单竖线隔开 0|2|3 ]
 * @param  {[STRING]} values:       [当前选中值 ]
 * @param  {[BOOLEN]} showButton:   [是否需要快捷选择按钮 ]
 * @param  {[NUMBER]} maxcodecount: [最多可以选择号码数]
 * @param  {[NUMBER]} index:        [当前行 ]
 * @param  {[FUNCTION]} onChange:   [变更时候的方法]
 * @author: ammo
 */
export default class BetDigital extends React.Component {

	constructor(props) {
		super(props);
    this.makeDisplay = this.makeDisplay.bind(this)
	}

	// 点击
	handleClick(selectValue){
    const {items, values, onChange, index, maxcodecount} = this.props;
    if (maxcodecount == values.length) {return}
    const arrayList = items.split('|');
    let result = null;
    switch (selectValue){
      // 全选
      case 'all': {
        result = arrayList;
        break;
      }
      // 大
      case 'big': {
        result = _.slice(arrayList, Math.floor( arrayList.length / 2 ))
        break;
      }
      // 小
      case 'small': {
        result = _.slice(arrayList, 0, Math.floor( arrayList.length / 2 ))
        break;
      }
      // 奇数
      case 'odd': {
        result = _.filter(arrayList, function(o) {if (o%2 === 1){return o}});
        break;
      }
      // 偶数
      case 'even': {
        result = _.filter(arrayList, function(o) {if (o%2 === 0){return o}});
        break;
      }
      // 清空
      case 'clear': {
        result = [];
        break;
      }
    }
    // 点击选择区
    if (!result) {
      // 已选
      if(selectValue.checked){
        result = _.remove(values, function(n){
          return n != selectValue.display
        })
      }else{
        // 没有选
        result = _.sortBy(_.concat(values, selectValue.display))
      }
    }
    onChange(result, index);
	}

	// 组装显示结果
	makeDisplay(items, values){
    const displayList = [];
    _.forEach(items.split('|'), function(item){
      let eachItem = {
        display: item,
        checked: _.includes(values, item)
      }
      displayList.push(eachItem);
    })
    return displayList
	}

	render() {
		const { title, items, values, showButton, missCodes, missCodeType, pos } = this.props;
    const displayList = this.makeDisplay(items, values);
    if(pos == '$'){
      return <div />
    }
		return (
			<div className={missCodes ? 'each show-miss-hot' : 'each'}>
        <div className={displayList.length > 15 ? 'mini inline-block codeBox' : 'inline-block codeBox'}>
          {
            title ? <h4 className={_.trim(title) == ""?"noHeight":null}>{title}</h4> : null
          }
  				<ul className='nList'>
  					{
  						displayList.map((item, index) => {
  							return <li 
                        key={index} 
                        onClick={this.handleClick.bind(this, item)} 
                        className={item.checked ? 'hover' : ''} >
                        {item.display}</li>
  						})
  					}
  				</ul>
          {
            showButton ?
              <ul className='cList'>
                <li onClick={this.handleClick.bind(this, 'all')} >全</li>
                <li onClick={this.handleClick.bind(this, 'big')} >大</li>
                <li onClick={this.handleClick.bind(this, 'small')} >小</li>
                <li onClick={this.handleClick.bind(this, 'odd')} >奇</li>
                <li onClick={this.handleClick.bind(this, 'even')} >偶</li>
                <li onClick={this.handleClick.bind(this, 'clear')} >清</li>
              </ul>: null
          }
        </div>
        {
          missCodes ? 
             <div className='miss-hot'>
                <span className='title'>{missCodeType == 1 ? '遗漏' : '冷热'}</span>
                <div className='code fl'>
                  {
                    _.map(missCodes, (item, index) => <span key={index} className={'code-color-' + item.status}>{item.count}</span>)
                  }
                </div>
              </div> : null
        }
			</div>
		);
	}
}
